var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgControl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_364_3610",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 44
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.394531,
    y: 0.905273,
    width: 44.2652,
    height: 42.8372,
    fill: "url(#pattern0_364_3610)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_364_3610)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.394531,
    y: 0.905273,
    width: 44.2652,
    height: 61.4001,
    fill: "#B2D9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_364_3610",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_364_3610",
    transform: "matrix(0.00826446 0 0 0.00853995 0 -0.0123968)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_364_3610",
    width: 121,
    height: 120,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHkAAAB4CAYAAADWpl3sAAAACXBIWXMAAAsSAAALEgHS3X78AAAEmklEQVR4nO2dzXHbMBBGNz8FsIOoBHUQpQOngqgD2xXErsBJBbYriH3MSbnmZKcCqwO5A2c0A85wMCSFXSwWAPG9GR6kA8nhE0BgdwERAAAAAAAAAAAAAAAAAAAAAAAAKRuDJ7cmog6G8nBLRG9EtE149aPgAxE9QbQ9veC3hKJ7wf01INoQX3AK0b5giDZkSrCm6CnBEG3AKcEaok8JhuiEhAqOER0qGKITwBUsEc0VDNGKSAVzREsFQ7QCsYJDRMcKhugItATPidYSnEz0u9RPOSOdEzBkx7ydZyK69L774332w5XfBAO2S3etnr07gABuq+L+KI5cCa6TNHb+PuXJQRlAcgNAcgNAcgNAcgNAcgNAcgMsORgyBnc++uoFKUJYuYPDs7sWAAAAkJIzFwPuD+77CkTy0eABrr0BzwoZlvo5Y+ZX+0zPZvBdz87L0kgyPEs6DpKeMMU8+RzVDcnoXCEE6/kiGFIfx17tF+euIblOWEEdSG4Ai9H1KdZugDV8z/SDsb5G68aF/TD9EpAidr0zWu/bOsHu0F03ACTXCSuYBMl1cp3zro+Dp5fGo1KpjyuuFM2W3CEBUSaaki9GlqWAAtCUfA6hZaLdXYMC0ZT8A4LL5IPiXf0mokci+ktE/9x3GITpcy+oIE1Kh0S/6nGQvBat6q7XbgX9kpDUZMfw6oIg7GtaFtcfW/R3w+vNMVfMHrrR6ZeRXQeaZ11IdxeSIVu56oup89y2LnOO3JK5KdCpjWUwoJygyyz4RXjfT955qhtbWGahrEOefjpOWuv90/v8KDxPNpYs+V7pPP6Po7rBlqXkz4bXopGpRrPvUUvJ1nVfx57jbvBZsm6YkFkL5yzTdOkodbhk54Z5393Ikp/qsGrJ3zI8mM7Ndb8O3quckGA3UipcVMy4JEqYOl25ooYQ1m5vzLEyppT/OFM1S0lQIMo1wxIK+9grCVtia9wt37hB3sZ1z3Px55Bj585XNamzUC9G89PrmVLVsX2vT4H9pgOxbMXoSjNh9S5mLcgGeli24urfmTViuVTm0PrDDiFFxOvCMBnwYHQdMGAs1ouuOjPa20lcGI5094KWzF0RuPcyWSFsBBm3u1qmbCvDFvwmyCiR4Br4yyAP63JbrcqPxaMleWOcodkj7ReOlmTrVuwX14EZNCRLBhqxYOrEQEOydZ71GckDHrGStxmqIDHgYhIrOccCNu68tXligiFXGVrxA+OvdSR55LFz+OONU/+f/ElwHf8+i8hnW4cv+4M7TWv+n9BjyFGcJ1plryh67gemJboYwZSpFceM4mNFh/QgsaKLEmxZEDA8YjNOUtGcV4RUdFGCKVOJrVZxAFe0JFTLFV2c4FxbQmgGXEJFx8TiQ0UXJ5hcvjiHZO2VhadEayRbTokuUjBleh9Lt4E4xZRozWzalOhiBVOm7lpSHBCKLzpFutQXXbTgntilJ9wjdVTtNqHgnl50FYLJ3aS/I06NrXiIxW4CqxpXemxdK0ghfBELzZaEdhxb9M+iYBqtVY2da9mx3dGryzShKAAAAAAAAAAAAAAAAAAAAAAAADJCRP8BlAyR74UB0qgAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControl);
export default __webpack_public_path__ + "static/media/control.669820dde68bdb737e4630ccbd120f1a.svg";
export { ForwardRef as ReactComponent };